import React from "react";
import { useTranslation } from "react-i18next";
import { BoxColor, ContainerExplain, ExplainWrapper } from "./styled";

const ExplainChart = () => {
  const { t } = useTranslation();
  return (
    <ExplainWrapper>
      <ContainerExplain>
        <BoxColor color="#CFAC00" />
        <span>{t("common.vaginalDelievery")}</span>
      </ContainerExplain>
      <ContainerExplain>
        <BoxColor color="#0089CF" />
        <span>{t("common.CSection")}</span>
      </ContainerExplain>
    </ExplainWrapper>
  );
};

export default ExplainChart;
